// import axios from 'axios'
import api from './api'
import axios from 'axios'

const UA = navigator.userAgent.toLowerCase()

function serialize(data) {
  if (!data) return '';
  var pairs = [],
    value;
  for (var name in data) {
    if (!data.hasOwnProperty(name)) continue;
    if (typeof data[name] === 'function') continue;
    value = data[name].toString();
    name = encodeURI(name);
    value = encodeURI(value);
    pairs.push(name + '=' + value);
  }
  if (pairs.length) {
    return '?' + pairs.join('&');
  } else {
    return ''
  }
}

function getApi(name) {
  return api[name] || name
}

/**
 * @method Post
 * @description post请求
 * @param {String} url - 请求地址，可以是api中定义的名称，或者具体的url地址
 * @param {Object} data - 请求参数
 * @param {*} config - 请求配置，详见axios文档 [https://github.com/mzabriskie/axios]
 */
export const Post = (url, data = {}, config = {}) => {
  return axios({
    method: 'post',
    url: getApi(url),
    data: {
      request_content: JSON.stringify(data)
    },
    ...config
    // adapter: config.mockFlag ? () => MOCK_DATA[config.mock] : null
  })
}

/**
 * @method Get
 * @description get请求, 判断运行环境为今日校园时，使用原生壳子提供的get方法（此方法可以解决跨域问题）；若运行环境不是今日校园，则使用axios的get请求方法
 * @param {String} url - 请求地址，可以是api中定义的名称，或者具体的url地址
 * @param {Object} data - 请求参数
 * @param {*} config - 运行环境是今日校园时，此参数为header参数；运行环境不是今日校园时，此参数为请求配置，详见axios文档 [https://github.com/mzabriskie/axios]；
 */
export const Get = (url, data = null, config = {}) => {
  return axios({
    method: 'get',
    url: getApi(url),
    params: {
      request_content: JSON.stringify(data)
    },
    ...config
  })
}
export const Get2 = (url, data = null, config = {}) => {
  return axios({
    method: 'get',
    url: getApi(url),
    params: data,
    ...config
  })
}
export const checkWxCode = function(cb) {
  Get('getWechatSign', {
    signUrl: window.location.href.split('#/')[0]
  }).then((response) => {
    let data = response.data;
    if (data.code === 0) {
      var jsApiList = [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone',
        'startRecord',
        'stopRecord',
        'onVoiceRecordEnd',
        'playVoice',
        'pauseVoice',
        'stopVoice',
        'onVoicePlayEnd',
        'uploadVoice',
        'downloadVoice',
        'chooseImage',
        'previewImage',
        'uploadImage',
        'downloadImage',
        'translateVoice',
        'getNetworkType',
        'openLocation',
        'getLocation',
        'hideOptionMenu',
        'showOptionMenu',
        'hideMenuItems',
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'showAllNonBaseMenuItem',
        'closeWindow',
        'scanQRCode',
        'chooseWXPay',
        'openProductSpecificView',
        'addCard',
        'chooseCard',
        'openCard',
        'previewFile',
        'updateAppMessageShareData',
        'updateTimelineShareData'
      ];
      if (/iphone/.test(navigator.userAgent.toLowerCase())) {
        jsApiList.push('getLocalImgData');
      };
      var config = {
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.result.appid, // 必填，公众号的唯一标识
        timestamp: data.result.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.result.nonceStr, // 必填，生成签名的随机串
        signature: data.result.signature, // 必填，签名
        jsApiList: jsApiList // 必填，需要使用的JS接口列表
      };

      // console.log('远端文件地址https://res.wx.qq.com')
      // let url = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js'; // 远端文件地址
      // var script = document.createElement("script");
      // script.src = url;
      // document.head.appendChild(script);
      // script.onload = () => {
      // debugger;
      if (wx) {
        wx.config(config);
        wx.ready((res) => {
          console.log('微信jssdk验证成功', res);
          cb && cb();
        });
        wx.error((res1) => {
          console.log('微信jssdk验证错误', res1);
        })
      } else {
        alert('无wx对象!请重试')
      }
      // };
    } else {
      Toast(data.msg || '微信验证权限失败！');
    }
  }).catch((error) => {
    Toast('微信验证权限失败！');
  })
}

export var Province = [
  // {
  //   value: "110000",
  //   label: "北京"
  // }, {
  //   value: "120000",
  //   label: "天津"
  // }, {
  //   value: "130000",
  //   label: "河北省"
  // }, {
  //   value: "140000",
  //   label: "山西省"
  // }, {
  //   value: "150000",
  //   label: "内蒙古自治区"
  // }, {
  //   value: "210000",
  //   label: "辽宁省"
  // }, {
  //   value: "220000",
  //   label: "吉林省"
  // }, {
  //   value: "230000",
  //   label: "黑龙江省"
  // }, {
  //   value: "310000",
  //   label: "上海"
  // }, {
  //   value: "320000",
  //   label: "江苏省"
  // }, {
  //   value: "330000",
  //   label: "浙江省"
  // }, {
  //   value: "340000",
  //   label: "安徽省"
  // }, {
  //   value: "350000",
  //   label: "福建省"
  // }, {
  //   value: "360000",
  //   label: "江西省"
  // }, {
  //   value: "370000",
  //   label: "山东省"
  // }, {
  //   value: "410000",
  //   label: "河南省"
  // }, {
  //   value: "420000",
  //   label: "湖北省"
  // }, {
  //   value: "430000",
  //   label: "湖南省"
  // }, {
  //   value: "440000",
  //   label: "广东省"
  // }, {
  //   value: "450000",
  //   label: "广西壮族自治区"
  // }, {
  //   value: "460000",
  //   label: "海南省"
  // }, {
  //   value: "500000",
  //   label: "重庆"
  // }, {
  //   value: "510000",
  //   label: "四川省"
  // }, {
  //   value: "520000",
  //   label: "贵州省"
  // }, {
  //   value: "530000",
  //   label: "云南省"
  // }, {
  //   value: "540000",
  //   label: "西藏自治区"
  // }, {
  //   value: "610000",
  //   label: "陕西省"
  // }, {
  //   value: "620000",
  //   label: "甘肃省"
  // }, {
  //   value: "630000",
  //   label: "青海省"
  // }, {
  //   value: "640000",
  //   label: "宁夏回族自治区"
  // }, {
  //   value: "650000",
  //   label: "新疆维吾尔自治区"
  // }, {
  //   value: "710000",
  //   label: "台湾省"
  // }, {
  //   value: "810000",
  //   label: "香港特别行政区"
  // }, {
  //   value: "820000",
  //   label: "澳门特别行政区"
  // }, {
  //   value: "990000",
  //   label: "海外"
  // }
]



export const Addsearchkeys = [{
  label: '成熟度',
  value: 'fruit_maturity',
  add: false
}, {
  label: '果重',
  value: 'fruit_weight',
  add: false
}, {
  label: '果形指数',
  value: 'fruit_shape',
  add: false
}, {
  label: '硬度',
  value: 'fruit_firmness',
  add: false
}, {
  label: '色度L*',
  value: 'color_l',
  add: false
}, {
  label: '色度a*',
  value: 'color_a',
  add: false
}, {
  label: '色度b*',
  value: 'color_b',
  add: false
}, {
  label: '可食率',
  value: 'edible_rate',
  add: false
}, {
  label: '水分',
  value: 'water_content',
  add: false
}, {
  label: '出汁率',
  value: 'juice_yield',
  add: false
}, {
  label: '可溶性固形物含量',
  value: 'soluble_solid_content',
  add: false
}, {
  label: '可滴定酸度',
  value: 'titrable_acidity',
  add: false
}, {
  label: '糖酸比',
  value: 'sugar_acid_ratio',
  add: false
}, {
  label: 'pH值',
  value: 'ph',
  add: false
}, {
  label: '能量',
  value: 'energy',
  add: false
}, {
  label: '蛋白质',
  value: 'protein',
  add: false
}, {
  label: '脂肪',
  value: 'fat',
  add: false
}, {
  label: '碳水化合物',
  value: 'carbohydrate',
  add: false
}, {
  label: '总膳食纤维',
  value: 'tdf',
  add: false
}, {
  label: '灰分',
  value: 'ash',
  add: false
}, {
  label: '总黄酮',
  value: 'flavone',
  add: false
}, {
  label: '总酚',
  value: 'phenols',
  add: false
}, {
  label: '适宜存储温度',
  value: 'temperature',
  add: false
}]
export const AddsearchKwzkeys = [{
  label: '钙',
  value: 'gai',
  add: false
}, {
  label: '锌',
  value: 'xin',
  add: false
}]
export const AddsearchWsskeys = [{
  label: '维生素A',
  value: 'wssA',
  add: false
}, {
  label: '维生素B',
  value: 'wssB',
  add: false
}]



// WEBPACK FOOTER //
// ./src/api/utils.js